<template lang="html">
  <div>
    <vs-card v-if="!displayForm" class="cardx">
      <div
        slot="header"
        style="padding: 10px; height: 100%; width: 100%; align-items: center"
      >
        <h3>
          <feather-icon
            @click="$router.go(-1)"
            icon="ArrowLeftIcon"
            class="cursor-pointer navbar-fuzzy-search mr-4"
          />
          Delete Users
          <div style="float: right">
            <vs-button
              class="mr-3 mb-3"
              @click="addNew"
              color="primary"
              type="filled"
              size="small"
              >Confirm delete</vs-button
            >
          </div>
        </h3>
      </div>

      <div>
        <input
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          ref="file"
          v-on:change="handleFilesUpload"
          type="file"
          style="height: 0px; visibility: hidden; position: absolute"
        />
        <vs-table
          stripe
          :sst="true"
          @search="handleSearch"
          :data="partner_users.partner_user"
          v-model="selected"
        >
          <template slot="thead">
            <vs-th sort-key="eco"> Name </vs-th>
            <vs-th sort-key="Phone"> Phone </vs-th>
            <vs-th sort-key="Email"> Email </vs-th>
            <vs-th> Code </vs-th>
            <vs-th> Created </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="item.id" :key="index" v-for="(item, index) in data">
              <vs-td>
                {{ item.name }}
              </vs-td>
              <vs-td>
                {{ item.phone }}
              </vs-td>
              <vs-td>
                {{ item.email }}
              </vs-td>
              <vs-td>
                {{ item.unlock_code }}
              </vs-td>
              <vs-td>
                {{ item.created_at }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <vs-popup
          @close="displayUserForm = false"
          class="crop-modal"
          title="Confirm Delete"
          :active.sync="displayUserForm"
        >
          <div>
            <vs-row>
              <vs-col vs-lg="12" vs-sm="6" vs-xs="12" style="padding: 10px">
                <vs-input
                  v-model="form.delete"
                  type="text"
                  name="delete"
                  v-validate="'required'"
                  :danger="errors.has('delete')"
                  :danger-text="
                    errors.has('delete') ? errors.first('delete') : null
                  "
                  val-icon-danger="close"
                  label="Confirm you want to delete"
                  placeholder="write delete"
                  style="width: 100%"
                />
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
                <vs-button
                  class="mr-3"
                  @click="displayUserForm = false"
                  color="danger"
                  type="filled"
                  >Cancel</vs-button
                >
                <vs-button
                  class="mr-3"
                  @click="saveUser"
                  color="primary"
                  type="filled"
                  >Continue</vs-button
                >
              </vs-col>
            </vs-row>
          </div>
        </vs-popup>
      </div>
    </vs-card>

    <vs-card
      v-if="displayForm"
      class="cardx card-100-h"
      v-bind:style="{ height: windowHeight - 155 + 'px' }"
    >
      <div>
        <vs-row>
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding: 10px">
            <div>
              <h3 style="margin-bottom: 10px">upload CSV of users to delete</h3>

              <div>
                <vs-row>
                  <vs-col
                    vs-lg="12"
                    vs-sm="12"
                    vs-xs="12"
                    style="padding: 10px"
                  >
                    <label class="vs-input--label">Zone</label>
                    <v-select
                      @input="filters.page = 1"
                      v-model="filters.zone_id"
                      :clearable="false"
                      :options="zones"
                      :reduce="(el) => el.id"
                      label="name"
                    />
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding: 10px">
                    <input
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv"
                      ref="fileCsv"
                      type="file"
                      @click="uploadFile"
                    />
                  </vs-col>
                </vs-row>
              </div>
              <div class="mb-4">
                <vs-button
                  class="mr-3"
                  @click="Masssave"
                  color="danger"
                  type="filled"
                  :disabled="showError"
                  >Save</vs-button
                >
                <vs-button @click="cancel" color="primary" type="filled"
                  >Cancel</vs-button
                >
              </div>
            </div>
          </vs-col>
        </vs-row>

        <vs-row v-if="showError">
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
            <h3>Import error</h3>
          </vs-col>
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
            <vs-table stripe :data="errors_array">
              <template slot="thead">
                <vs-th> unlock_code </vs-th>
                <vs-th> name </vs-th>
                <vs-th> phone </vs-th>
                <vs-th> email </vs-th>
                <vs-th> code </vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="indextr">
                    {{ parseInt(Object.keys(data[indextr])) }}
                  </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))].id
                    "
                  >
                    test
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))].id[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-row>
              <vs-col style="margintop: 10px">
                <vs-button
                  @click="showError = false"
                  color="primary"
                  type="filled"
                  size="small"
                  >Ok</vs-button
                >
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>

    <vs-popup title="Progress">
      <vs-row style="margin-bottom: 20px">
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-slider disabled="true" v-model="progress" :min="0" :max="100" />
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-popup
      @close="showProgress = false"
      button-close-hidden
      class="crop-modal"
      title="Import Progress"
      :active.sync="showProgress"
    >
      <vs-row>
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
          Progress of import:
        </vs-col>
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
          <div
            :style="{
              background: 'red',
              height: '15px',
              width: progress + '%',
            }"
          ></div>
          <div
            style="
              fontsize: 1rem;
              fontweight: bold;
              color: red;
              textalign: center;
            "
          >
            {{ progress }}%
          </div>
        </vs-col>
        <vs-col
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
          style="padding: 10px; textalign: center"
          v-if="progress === 100"
        >
          <vs-button
            @click="closeProgress"
            color="primary"
            type="filled"
            size="small"
            >Ok</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import Orders from "../../orders/data";
import VueQr from "vue-qr";
import html2canvas from "html2canvas";
import Datepicker from "vuejs-datepicker";
import XLSX from "xlsx";
import moment from "moment";
import { isEqual, isEmpty } from "lodash";
const FileDownload = require("js-file-download");
import limitOptions from "../../../constants/limit";
import { qrSizes } from "../../../constants/utils";

export default {
  name: "Delete",
  components: {
    orders: Orders,
    VueQr,
  },
  data() {
    return {
      page: 0,
      search: null,
      customer: null,
      filters: { type: null },
      qr_code: null,
      qr_value: "",
      display_qr: false,
      user: null,
      displayUserForm: false,
      displayForm: false,
      form: {
        delete: "",
      },
      windowHeight: 0,
      showError: false,
      showProgress: false,
      progress: 0,
      dates: {
        page: 0,
        to_date: moment().subtract(1, "days").toDate(),
        from_date: moment().toDate(),
      },
      partner_users: {
        pagination: {},
        partner_user: [],
        pagination: {
          page: 1,
          limit: 10,
          total: 0,
          pages: 0,
          prev: null,
          next: null,
        },
      },
      userTypes: [
        { label: "All", value: null },
        { label: "Online", value: "online" },
        { label: "Offline", value: "offline" },
      ],
      userStatus: [
        { label: "All", value: null },
        { label: "Active", value: true },
        { label: "Desactive", value: false },
      ],
      selected: [],
      qrForm: {
        type: null,
      },
      showQrForm: false,
      limitOptions,
      qrSizes,
    };
  },
  computed: {
    ...mapState("partners", ["currentPage"]),
    ...mapState("users", ["currentUser"]),
    ...mapState("zones", ["zones"]),
    to_date() {
      return moment(this.dates.to_date).format("YYYY-MM-DD");
    },
    from_date() {
      return moment(this.dates.from_date).format("YYYY-MM-DD");
    },
  },
  watch: {
    filters: {
      deep: true,
      handler(newVal, oldVal) {
        this.setRouteQuery();
        this.doSearch();
      },
    },
  },
  created() {
    this.filters = {
      limit: "20",
      ...this.$route.query,
      page: this.$route.query.page ? Number(this.$route.query.page) : 1,
      zone_id: this.$route.query.zone_id
        ? this.$route.query.zone_id
        : this.zones.length > 0
        ? this.zones[0].id
        : null,
    };
    this.doSearch = _.debounce(this.getItems, 300);
    if (this.$route.params.id === "CSV") {
      this.displayForm = true;
    } else {
      this.displayForm = false;
    }
  },
  components: {
    Datepicker,
    VueQr,
  },
  methods: {
    ...mapGetters("users", ["userCan"]),
    ...mapActions("partners", [
      "fetchPartnerUsers",
      "downloadQrCodes",
      "storePartnerUser",
      "deletePartnerUser",
      "getPartnerZones",
      "downloadPartnerUsers",
      "MassLoadUsers",
      "CheckUsersProgress",
      "UsersActivate",
      "DeletedIDS",
      "DeletedCSV",
      "DeletedUsersProgress",
    ]),
    ...mapMutations("partners", ["SET_PARTNER_USERS"]),
    setRouteQuery() {
      let query = { ...this.filters, page: `${this.filters.page}` };
      if (!_.isEqual(query, this.$route.query)) {
        try {
          this.$router.push({ query });
        } catch (error) {}
      }
    },
    getItems(search) {
      if (!this.userCan("capacity_control_user.read")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }

      this.$vs.loading({ type: "point" });
      let payload = _.cloneDeep(this.filters);
      payload.partner_id = this.currentUser.partner;

      if (payload.is_active === 0) {
        delete payload.is_active;
      }

      this.fetchPartnerUsers(payload)
        .then((data) => {
          let arrayData = [];
          let localArrayUsers = localStorage.getItem("selectedUsers");
          localArrayUsers = JSON.parse(localArrayUsers);
          localArrayUsers.map((i, index) => {
            data.partner_user.map((item, idx) => {
              if (item.id === i) {
                arrayData.push(item);
              }
            });
          });
          this.partner_users = {
            pagination: data.pagination,
            partner_user: arrayData,
          };
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    handleSearch(searching) {
      this.filters = { ...this.filters, page: 1, search: searching };
    },
    handleSelected(tr) {
      //this.$router.push({name:'customers.detail', params: {id: tr.id}});
      /*
        this.customer = tr;
        this.filters =  {
          customer_id : this.customer.id,
        };
        //this.filters = [{ field: 'customer.id', op: '=', value: this.customer.id}]

         */
    },
    displayQrCode(user) {
      this.user = user;
      this.display_qr = true;
    },
    onQrCallback(imageUri) {
      this.qr_code = imageUri;
    },
    downloadQR() {
      html2canvas(document.getElementById("qrcode"), {
        scrollY: 0,
        scrollX: 0,
      }).then((canvas) => {
        //document.body.appendChild(canvas);
        let linkSource = canvas.toDataURL("image/png");
        linkSource = linkSource.replace(
          /^data:image\/png/,
          "data:application/octet-stream"
        );
        //const linkSource = this.qr_code;
        const downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);

        downloadLink.href = linkSource;
        downloadLink.target = "_self";
        downloadLink.download = `QRcode_${this.user.id}.png`;
        downloadLink.click();
      });
    },
    downloadAllUsers() {
      this.$vs.loading({ type: "point" });
      // this.fetchPartnerUsers({
      //   ...this.filters,
      //   partner_id: this.currentUser.partner,
      //   limit:100000
      // })
      //   .then(response=>{
      //     this.$vs.loading.close();
      //     let jsonArr = response.partner_user.map(item=>({
      //       name: item.name,
      //       email: item.email,
      //       phone: item.phone,
      //       code: item.unlock_code,
      //     }));

      //     let data = XLSX.utils.json_to_sheet(jsonArr);

      //     const workbook = XLSX.utils.book_new();
      //     const filename = 'users';
      //     XLSX.utils.book_append_sheet(workbook, data, filename);
      //     XLSX.writeFile(workbook, `users-${moment().format()}.xls`);

      //   })
      //   .catch(error =>{
      //     this.$vs.loading.close();
      //   })
      let filters1 = {
        zone_id: this.filters.zone_id,
        type: this.filters.type,
        page: this.filters.page,
        is_active: this.filters.is_active,
        from_date: this.filters.from_date,
        to_date: this.filters.to_date,
      };
      if (filters1.is_active === 0) {
        delete filters1.is_active;
      }

      this.downloadPartnerUsers(filters1)
        .then((response) => {
          this.$vs.loading.close();
          FileDownload(response, `users-${moment().format()}.csv`);
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    MassLoad() {
      console.log("mass load");
      this.formTitle = "Mass Charge";
      this.displayForm = true;
    },
    uploadFile() {
      console.log("uploadFile");
      this.showError = false;
    },
    Masssave() {
      if (this.filters.zone_id) {
        this.handleFilesUploadCSV();
      } else {
        alert("Select a Zone.");
      }
    },
    cancel() {
      this.$router.back();
    },
    handleFilesUploadCSV() {
      this.submitFileCsv(this.$refs.fileCsv.files[0]);
    },
    submitFileCsv(file) {
      this.$vs.loading({ type: "point" });
      let formDataCsv = new FormData();
      formDataCsv.append("partner_id", this.currentUser.partner);
      formDataCsv.append("zone_id", this.filters.zone_id);
      formDataCsv.append("file", file);
      console.log("FORM", formDataCsv);
      this.DeletedCSV(formDataCsv)
        .then((data) => {
          if (data.id) {
            this.checkprogress(data.id);
            this.$vs.loading.close();
          }
        })
        .catch((error) => {
          console.log("error1:", error);
          if (error.status === 400) {
            this.errors_array = null;
            this.errors_array = error.data.errors;
            this.errors_detail = error.data.detail;
            this.showError = true;
          }
          this.$vs.loading.close();
        });
    },
    checkprogress(data_id) {
      let payload = { task_id: data_id };
      this.DeletedUsersProgress(payload)
        .then((data) => {
          /* for (var i=0; i < this.partners.partners.length; i++) {
              if (this.partners.partners[i].id === this.partner_id) {
                  this.partnernamespace= this.partners.partners[i].name;
              }
          }*/
          this.progress = 0;
          console.log("DeletedUsersProgress data", data);
          this.showProgress = true;
          if (data.status === "FAILURE") {
            this.errors_array = null;
            this.errors_array = data.errors;
            this.showError = true;
            this.showProgress = false;
            this.$vs.loading.close();

            setTimeout(() => {}, 500);
            return false;
          }
          if (data.progress != 100) {
            this.progress = data.progress;
            setTimeout(() => {
              this.checkprogress(data_id);
            }, 1000);
          } else {
            localStorage.removeItem("selectedUsers");
            this.progress = 100;
            this.displayForm = false;
            setTimeout(() => {
              this.$router.back();
            }, 500);
          }
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.log("DeletedUsersProgress error:", error);
          alert("Error on Import.");
          this.progress = 0;
          this.showProgress = false;
          this.$vs.loading.close();
        });
    },
    userActive(item) {
      console.log("item", item);
      // this.isActive = this.isActive ? false : true;
      // console.log('isactive', this.isActive);
      this.UsersActivate(item)
        .then((data) => {
          console.log("UsersActivate:", data);
          this.getItems();
        })
        .catch((error) => {
          console.log("UsersActivate error:", error);
        });
    },
    promptQr(type) {
      let form = {
        type: type,
        zone_id: this.filters.zone_id,
        size: "610X700",
        display_name: true,
        is_active: this.filters.is_active,
        from_date: this.filters.from_date,
        to_date: this.filters.to_date,
      };
      if (type === "IDS") {
        var temparray = [];
        for (var i = 0; i < this.selected.length; i++) {
          if (this.selected[i].id) {
          } else {
            temparray.push(this.selected[i]);
          }
        }
        form.ids = temparray;
      }
      this.qrForm = _.cloneDeep(form);
      this.showQrForm = true;
    },
    closeQrPrompt() {},
    updateDateQuery() {
      console.log("update query", this.dates.to);
      //date.since

      this.page = 1;
      this.filters = {
        ...this.filters,
        page: 1,
        from_date: this.from_date,
        to_date: this.to_date,
      };
    },
    sendQr() {
      this.$validator.validateAll("qr").then((result) => {
        this.showQrForm = !result;
        if (result) {
          this.downloadQrCodes(_.cloneDeep(this.qrForm))
            .then((response) => {
              this.qrForm = {};
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: "We will send you an email with QR codes",
              });
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: "Oops, something went wrong! Try later",
              });
            });
        }
      });
    },

    addNew() {
      if (!this.userCan("capacity_control_user.create")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }
      this.displayUserForm = true;
    },

    async saveUser() {
      if (this.form.delete === "delete") {
        this.displayUserForm = false;
        this.$vs.loading({ type: "point" });
        let localArrayUsers = localStorage.getItem("selectedUsers");
        localArrayUsers = JSON.parse(localArrayUsers);
        let payload = {
          ids: localArrayUsers,
        };
        this.DeletedIDS(payload)
          .then((data) => {
            console.log("deleted", data);
            this.checkprogress(data.id);
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Something went wrong",
            });
          });
      } else {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "you must write delete",
        });
        this.form.delete = "";
      }
    },
    handleFilesUpload() {
      this.submitFile(this.$refs.file.files[0]);
    },
    submitFile(file) {
      let formData = new FormData();
      formData.append("file", file);
      axios
        .post("/api/v1/employees/import", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {})
        .catch((error) => {});
    },

    setErrors(errors) {
      this.errors.clear();
      for (let key in errors) {
        if (Array.isArray(errors[key])) {
          this.errors.add({
            field: key,
            msg: errors[key][0],
          });
        }
      }
    },

    deleteUser(id) {
      if (!this.userCan("capacity_control_user.delete")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure yo want to delete this record?\n This cannot be undone!",
        accept: () => {
          this.deletePartnerUser({ id: id, zone_id: this.$route.query.zone_id })
            .then((data) => {
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: "Deleted successfully",
              });
              this.getItems();
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: "Something went wrong",
              });
            });
        },
      });
    },
    closeProgress() {
      this.showProgress = false;
      setTimeout(() => {
        this.$router.back();
      }, 800);
    },
  },
};
</script>
